import React, {Component} from 'react';
import {Layout, Menu, Icon} from 'antd';
import {Link, Redirect, Route, Switch} from 'react-router-dom';
import Head from "../components/Head";
import Iconz from "../components/Iconz";
import FIndex from "./feedback/Class";
import FList from "./feedback/List";
import MyFeedback from "./feedback/MyFeedback";
import {app} from "../app";
import '../css/feedback.css';

const {Sider, Content, Header} = Layout;

class Feedback extends Component {
    constructor(props) {
        super(props);
        const path = props.location.pathname;
        let menu_current = '2';
        if (path === "/feedback/my") {
            menu_current = '1';
        }
        this.state = {
            menu_current: menu_current
        };
    }

    /**
     * 点击菜单
     * @param e
     */
    handleMenuClick = (e) => {
        const key = e.key, {history} = this.props;
        this.setState({menu_current: key,}, () => {
            switch (key) {
                case '1':
                    history.replace('/feedback');
                    break;
                case '2':
                    history.replace('/feedback/my');
                    break;
            }
        });
    }

    render() {
        const isLogin = app.checkLogin();
        if (isLogin) {
            return (<Redirect to="/"/>);
        } else {
            return (
                <Layout className="ranks">
                    <Sider style={{width: 200, background: "#3C474F"}}>
                        <div className="r_left_logo">
                            <Iconz type="icon-logo_" size={48}/>
                        </div>
                        <Menu
                            className="r_left_menu"
                            theme="dark"
                            onSelect={this.handleMenuClick}
                            selectedKeys={[this.state.menu_current]}
                            mode="inline"
                            style={{background: "#3C474F"}}
                        >
                            <Menu.Item key="1"><Icon type="message"/><span>我的反馈</span></Menu.Item>
                            <Menu.Item key="2"><Icon type="exception"/><span>反馈</span></Menu.Item>
                        </Menu>
                    </Sider>
                    <Layout>
                        <Header className="r_right_head"><Head notLogin={true} background="#3F89C1" height={78}
                                                               history={this.props.history}/></Header>
                        <Content className="r_right_content">
                            <Switch>
                                <Route exact path="/feedback/list/:id" component={FList}/>
                                <Route exact path="/feedback/my" component={MyFeedback}/>
                                <Route exact path="/feedback" component={FIndex}/>
                                <Route render={() => <Redirect to="/feedback"/>}/>
                            </Switch>
                        </Content>
                    </Layout>
                </Layout>
            );
        }
    }
}

export default Feedback;



// WEBPACK FOOTER //
// ./src/routes/Feedback.jsx